// extracted by mini-css-extract-plugin
export default {"tags":"TagsList_tags__0ZbJq","tag":"TagsList_tag__qQGDJ"};